import { TrendingDown, TrendingUp } from 'lucide-react';

import { Card, CardContent, CardHeader, CardTitle } from '@/_shared/components/ui/card';
import { Skeleton } from '@/_shared/components/ui/skeleton';
import { formatValue } from '@/_shared/lib/charts/format';
import { cn } from '@/_shared/lib/utils';

interface MetricCardProps {
  title: string;
  value: number | null;
  format?: 'number' | 'percent' | 'currency';
  prefix?: string;
  suffix?: string;
  delta?: number;
  loading?: boolean;
}

export function MetricCard({
  title,
  value,
  format = 'number',
  prefix,
  suffix,
  delta,
  loading,
}: MetricCardProps): React.ReactElement {
  if (loading) {
    return (
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">{title}</CardTitle>
        </CardHeader>
        <CardContent>
          <Skeleton className="h-8 w-24" />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold text-foreground tabular-nums">
          {value !== null ? formatValue(value, format, prefix, suffix) : '\u2014'}
        </div>
        {delta !== undefined && (
          <div className={cn('mt-1 flex items-center gap-1 text-xs', delta >= 0 ? 'text-green-700' : 'text-red-700')}>
            {delta >= 0 ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
            <span>
              {delta >= 0 ? '+' : ''}
              {delta.toFixed(1)}%
            </span>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
